var map = {
	"./core/data/country-code-phone-prefix": 72913,
	"./core/data/country-code-phone-prefix.json": 72913,
	"./core/data/country-list": 78631,
	"./core/data/country-list.json": 78631,
	"./core/images/boxy/default-background.jpg": 79587,
	"./core/images/boxy/default-background.webp": 70619,
	"./core/images/boxy/default-background_2.jpg": 70506,
	"./core/images/boxy/default-background_2.webp": 25353,
	"./core/images/index.html": 26727,
	"./core/images/logos/main.png": 30689,
	"./core/images/logos/main.svg": 11882,
	"./core/images/sidecut/bg1.jpg": 18455,
	"./core/images/sidecut/bg2.jpg": 5892,
	"./core/images/sidecut/bg3.jpg": 63807,
	"./core/images/user/login/boxy_background.jpg": 44683,
	"./core/images/user/login/boxy_background_2.jpg": 20923,
	"./core/index.html": 95230,
	"./core/nav/adminSideNavFactory": 38718,
	"./core/nav/adminSideNavFactory.js": 38718,
	"./core/nav/userDashboardNavFactory": 13827,
	"./core/nav/userDashboardNavFactory.js": 13827,
	"./ecommerce/headers/sample_header.jpg": 44928,
	"./ecommerce/headers/sample_header_2.jpg": 54216,
	"./ecommerce/headers/sample_header_3.jpg": 32164,
	"./icons/a-test/test-icon.svg": 54955,
	"./icons/rubicons/3d-scan.svg": 20315,
	"./icons/rubicons/airplay.svg": 1684,
	"./icons/rubicons/alarm.svg": 71441,
	"./icons/rubicons/align-center-alt.svg": 18229,
	"./icons/rubicons/align-center.svg": 80155,
	"./icons/rubicons/align-justify-alt.svg": 72802,
	"./icons/rubicons/align-justify.svg": 10027,
	"./icons/rubicons/align-left-alt.svg": 7426,
	"./icons/rubicons/align-left.svg": 6599,
	"./icons/rubicons/align-right-alt.svg": 14021,
	"./icons/rubicons/align-right.svg": 37021,
	"./icons/rubicons/archive.svg": 32179,
	"./icons/rubicons/arrow-down-circle.svg": 75955,
	"./icons/rubicons/arrow-down-small.svg": 19231,
	"./icons/rubicons/arrow-down-square.svg": 66317,
	"./icons/rubicons/arrow-down.svg": 87610,
	"./icons/rubicons/arrow-download-alt.svg": 92542,
	"./icons/rubicons/arrow-download.svg": 20231,
	"./icons/rubicons/arrow-left-circle.svg": 22304,
	"./icons/rubicons/arrow-left-down.svg": 64336,
	"./icons/rubicons/arrow-left-small.svg": 34694,
	"./icons/rubicons/arrow-left-square.svg": 27244,
	"./icons/rubicons/arrow-left-up.svg": 61305,
	"./icons/rubicons/arrow-left.svg": 49004,
	"./icons/rubicons/arrow-login-left-alt.svg": 94064,
	"./icons/rubicons/arrow-login-left.svg": 89266,
	"./icons/rubicons/arrow-login-right-alt.svg": 18414,
	"./icons/rubicons/arrow-login-right.svg": 8270,
	"./icons/rubicons/arrow-logout-left-alt.svg": 5785,
	"./icons/rubicons/arrow-logout-left.svg": 66566,
	"./icons/rubicons/arrow-logout-right-alt.svg": 7338,
	"./icons/rubicons/arrow-logout-right.svg": 43569,
	"./icons/rubicons/arrow-right-circle.svg": 741,
	"./icons/rubicons/arrow-right-down.svg": 43062,
	"./icons/rubicons/arrow-right-small.svg": 68803,
	"./icons/rubicons/arrow-right-square.svg": 28234,
	"./icons/rubicons/arrow-right-up.svg": 27114,
	"./icons/rubicons/arrow-right.svg": 41952,
	"./icons/rubicons/arrow-up-circle.svg": 19485,
	"./icons/rubicons/arrow-up-small.svg": 44205,
	"./icons/rubicons/arrow-up-square.svg": 70015,
	"./icons/rubicons/arrow-up.svg": 74610,
	"./icons/rubicons/arrow-upload-alt.svg": 4209,
	"./icons/rubicons/arrow-upload.svg": 72271,
	"./icons/rubicons/arrows-sort.svg": 19458,
	"./icons/rubicons/article.svg": 47698,
	"./icons/rubicons/bag-alt.svg": 28805,
	"./icons/rubicons/bag-plus.svg": 80434,
	"./icons/rubicons/bag.svg": 24173,
	"./icons/rubicons/bar-code.svg": 73851,
	"./icons/rubicons/basket.svg": 40594,
	"./icons/rubicons/battery-charging.svg": 13864,
	"./icons/rubicons/battery-empty.svg": 74296,
	"./icons/rubicons/battery-full.svg": 92327,
	"./icons/rubicons/battery-half.svg": 7152,
	"./icons/rubicons/bell.svg": 28726,
	"./icons/rubicons/binder.svg": 58971,
	"./icons/rubicons/bluetooth.svg": 42118,
	"./icons/rubicons/book.svg": 24162,
	"./icons/rubicons/bookmark.svg": 20453,
	"./icons/rubicons/brands-codepen.svg": 64051,
	"./icons/rubicons/brands-codesandbox.svg": 61263,
	"./icons/rubicons/brands-dribbble.svg": 47867,
	"./icons/rubicons/brands-dropbox.svg": 4941,
	"./icons/rubicons/brands-facebook.svg": 14765,
	"./icons/rubicons/brands-figma.svg": 40654,
	"./icons/rubicons/brands-github.svg": 88492,
	"./icons/rubicons/brands-google.svg": 4854,
	"./icons/rubicons/brands-instagram.svg": 29473,
	"./icons/rubicons/brands-linkedin.svg": 24588,
	"./icons/rubicons/brands-paypal.svg": 92353,
	"./icons/rubicons/brands-snapchat.svg": 68523,
	"./icons/rubicons/brands-stripe.svg": 95810,
	"./icons/rubicons/brands-twitter.svg": 73456,
	"./icons/rubicons/brands-youtube.svg": 7848,
	"./icons/rubicons/bug.svg": 43650,
	"./icons/rubicons/calendar.svg": 11307,
	"./icons/rubicons/camera-alt.svg": 70623,
	"./icons/rubicons/camera.svg": 24502,
	"./icons/rubicons/cart-basket.svg": 41170,
	"./icons/rubicons/cart-plus.svg": 12938,
	"./icons/rubicons/cart.svg": 9703,
	"./icons/rubicons/cassette.svg": 11269,
	"./icons/rubicons/chart-bar-alt.svg": 32578,
	"./icons/rubicons/chart-bar.svg": 72034,
	"./icons/rubicons/chart-intersect.svg": 92279,
	"./icons/rubicons/chart-line.svg": 60159,
	"./icons/rubicons/chart-pie.svg": 16174,
	"./icons/rubicons/chat-alt.svg": 86537,
	"./icons/rubicons/chat-incoming-alt.svg": 79870,
	"./icons/rubicons/chat-incoming.svg": 72822,
	"./icons/rubicons/chat-message-alt.svg": 45301,
	"./icons/rubicons/chat-message.svg": 36053,
	"./icons/rubicons/chat.svg": 87932,
	"./icons/rubicons/check-circle.svg": 2222,
	"./icons/rubicons/check-list.svg": 6151,
	"./icons/rubicons/check-square.svg": 51684,
	"./icons/rubicons/check.svg": 65186,
	"./icons/rubicons/chevron-down.svg": 88442,
	"./icons/rubicons/chevron-left.svg": 52891,
	"./icons/rubicons/chevron-right.svg": 11618,
	"./icons/rubicons/chevron-up.svg": 17820,
	"./icons/rubicons/chevrons-down.svg": 76222,
	"./icons/rubicons/chevrons-left.svg": 68655,
	"./icons/rubicons/chevrons-right.svg": 52636,
	"./icons/rubicons/chevrons-up.svg": 96142,
	"./icons/rubicons/circle-fill.svg": 69549,
	"./icons/rubicons/circle-piece.svg": 76661,
	"./icons/rubicons/clipboard-check.svg": 53730,
	"./icons/rubicons/clipboard-x.svg": 52556,
	"./icons/rubicons/clipboard.svg": 8040,
	"./icons/rubicons/clock.svg": 32426,
	"./icons/rubicons/clone-reverse.svg": 39077,
	"./icons/rubicons/clone.svg": 19933,
	"./icons/rubicons/cloud-alt.svg": 98605,
	"./icons/rubicons/cloud-download.svg": 18990,
	"./icons/rubicons/cloud-rain.svg": 87497,
	"./icons/rubicons/cloud-upload.svg": 44379,
	"./icons/rubicons/cloud.svg": 51686,
	"./icons/rubicons/code-arrow-brackets.svg": 75498,
	"./icons/rubicons/code.svg": 28870,
	"./icons/rubicons/collapse.svg": 18104,
	"./icons/rubicons/color-palette.svg": 12954,
	"./icons/rubicons/command.svg": 17491,
	"./icons/rubicons/contrast.svg": 24892,
	"./icons/rubicons/copy-alt-reverse.svg": 43059,
	"./icons/rubicons/copy-alt.svg": 71618,
	"./icons/rubicons/copy-content-reverse.svg": 81923,
	"./icons/rubicons/copy-content.svg": 94568,
	"./icons/rubicons/copy-page-reverse.svg": 76317,
	"./icons/rubicons/copy-page.svg": 83842,
	"./icons/rubicons/copy-reverse.svg": 20273,
	"./icons/rubicons/copy.svg": 58856,
	"./icons/rubicons/credit-cards.svg": 44688,
	"./icons/rubicons/crop.svg": 90312,
	"./icons/rubicons/cube-multi.svg": 93184,
	"./icons/rubicons/cube.svg": 52894,
	"./icons/rubicons/dashboard.svg": 87923,
	"./icons/rubicons/degree.svg": 3496,
	"./icons/rubicons/drop.svg": 31276,
	"./icons/rubicons/email.svg": 87833,
	"./icons/rubicons/export.svg": 42471,
	"./icons/rubicons/eye-alt.svg": 93033,
	"./icons/rubicons/eye-hidden.svg": 26515,
	"./icons/rubicons/eye.svg": 8718,
	"./icons/rubicons/file-copy.svg": 42889,
	"./icons/rubicons/file-zip.svg": 36958,
	"./icons/rubicons/file.svg": 50795,
	"./icons/rubicons/fire.svg": 39452,
	"./icons/rubicons/flag.svg": 15962,
	"./icons/rubicons/floppy-disk.svg": 89659,
	"./icons/rubicons/folder-copy.svg": 95339,
	"./icons/rubicons/folder-minus.svg": 78673,
	"./icons/rubicons/folder-open-alt.svg": 11370,
	"./icons/rubicons/folder-open.svg": 64334,
	"./icons/rubicons/folder-plus.svg": 229,
	"./icons/rubicons/folder.svg": 9680,
	"./icons/rubicons/go-back.svg": 147,
	"./icons/rubicons/go-forward.svg": 61691,
	"./icons/rubicons/grid-alt-reverse.svg": 40736,
	"./icons/rubicons/grid-alt.svg": 73130,
	"./icons/rubicons/grid-reverse.svg": 83478,
	"./icons/rubicons/grid.svg": 23113,
	"./icons/rubicons/handle-horizontal.svg": 94001,
	"./icons/rubicons/handle-vertical.svg": 38363,
	"./icons/rubicons/hard-drive.svg": 93268,
	"./icons/rubicons/hashtag.svg": 9892,
	"./icons/rubicons/headphones.svg": 74785,
	"./icons/rubicons/heart.svg": 26617,
	"./icons/rubicons/home.svg": 64789,
	"./icons/rubicons/hotspot-alt.svg": 35843,
	"./icons/rubicons/hotspot.svg": 67595,
	"./icons/rubicons/image.svg": 77329,
	"./icons/rubicons/import.svg": 2407,
	"./icons/rubicons/inbox-file.svg": 42282,
	"./icons/rubicons/inbox.svg": 1919,
	"./icons/rubicons/info.svg": 29012,
	"./icons/rubicons/iphone.svg": 56028,
	"./icons/rubicons/keyboard-hide.svg": 64932,
	"./icons/rubicons/keyboard.svg": 82869,
	"./icons/rubicons/language.svg": 63829,
	"./icons/rubicons/laptop.svg": 88982,
	"./icons/rubicons/layer-stack.svg": 80449,
	"./icons/rubicons/life-float.svg": 40617,
	"./icons/rubicons/lightbulb.svg": 41016,
	"./icons/rubicons/link-alt.svg": 26865,
	"./icons/rubicons/link.svg": 22957,
	"./icons/rubicons/location.svg": 88168,
	"./icons/rubicons/lock-alt.svg": 49269,
	"./icons/rubicons/lock.svg": 36270,
	"./icons/rubicons/magnify-minus.svg": 21645,
	"./icons/rubicons/magnify-plus.svg": 55001,
	"./icons/rubicons/magnify.svg": 98980,
	"./icons/rubicons/mail-alt.svg": 81282,
	"./icons/rubicons/mail.svg": 54126,
	"./icons/rubicons/map-pin-location-alt.svg": 84174,
	"./icons/rubicons/map-pin-location.svg": 24733,
	"./icons/rubicons/map-pin.svg": 40591,
	"./icons/rubicons/map.svg": 95797,
	"./icons/rubicons/maximize.svg": 9615,
	"./icons/rubicons/mc-fast-forward.svg": 80572,
	"./icons/rubicons/mc-pause.svg": 80538,
	"./icons/rubicons/mc-play.svg": 27513,
	"./icons/rubicons/mc-repeat-all.svg": 22530,
	"./icons/rubicons/mc-repeat-one.svg": 80,
	"./icons/rubicons/mc-repeat.svg": 69143,
	"./icons/rubicons/mc-shuffle.svg": 60320,
	"./icons/rubicons/mc-skip-back.svg": 13808,
	"./icons/rubicons/mc-skip.svg": 14326,
	"./icons/rubicons/mc-volume-off.svg": 33659,
	"./icons/rubicons/mc-volume.svg": 37647,
	"./icons/rubicons/menu-grid.svg": 90267,
	"./icons/rubicons/mic-off.svg": 90797,
	"./icons/rubicons/mic.svg": 52787,
	"./icons/rubicons/minimize.svg": 24940,
	"./icons/rubicons/minus-circle.svg": 85797,
	"./icons/rubicons/minus-square.svg": 52441,
	"./icons/rubicons/minus.svg": 7261,
	"./icons/rubicons/monitor.svg": 23133,
	"./icons/rubicons/moon.svg": 5738,
	"./icons/rubicons/mouse.svg": 50402,
	"./icons/rubicons/move.svg": 43385,
	"./icons/rubicons/paperclip-alt.svg": 36126,
	"./icons/rubicons/paperclip.svg": 44001,
	"./icons/rubicons/paragraph.svg": 71513,
	"./icons/rubicons/pen-tool.svg": 99155,
	"./icons/rubicons/pen.svg": 82114,
	"./icons/rubicons/pencil-draw.svg": 71080,
	"./icons/rubicons/pencil-write.svg": 18390,
	"./icons/rubicons/pencil.svg": 78089,
	"./icons/rubicons/percent.svg": 73115,
	"./icons/rubicons/phone-hangup.svg": 91804,
	"./icons/rubicons/phone-receiving.svg": 11338,
	"./icons/rubicons/phone-ringing.svg": 95896,
	"./icons/rubicons/plus-circle.svg": 50598,
	"./icons/rubicons/plus-square.svg": 65482,
	"./icons/rubicons/plus.svg": 74535,
	"./icons/rubicons/print.svg": 32587,
	"./icons/rubicons/qr-code.svg": 33763,
	"./icons/rubicons/question.svg": 56300,
	"./icons/rubicons/redo-alt.svg": 31321,
	"./icons/rubicons/redo.svg": 17590,
	"./icons/rubicons/refresh.svg": 14666,
	"./icons/rubicons/resize-alt-reverse.svg": 66679,
	"./icons/rubicons/resize-alt.svg": 43004,
	"./icons/rubicons/resize-reverse.svg": 38403,
	"./icons/rubicons/resize.svg": 50751,
	"./icons/rubicons/rss.svg": 25990,
	"./icons/rubicons/scan.svg": 37778,
	"./icons/rubicons/send-alt.svg": 58923,
	"./icons/rubicons/send.svg": 62236,
	"./icons/rubicons/server-alt.svg": 37643,
	"./icons/rubicons/server-cloud.svg": 31204,
	"./icons/rubicons/server.svg": 82197,
	"./icons/rubicons/settings.svg": 8024,
	"./icons/rubicons/shape-circle.svg": 40127,
	"./icons/rubicons/shape-square.svg": 10058,
	"./icons/rubicons/shape-triangle.svg": 14393,
	"./icons/rubicons/shapes.svg": 9097,
	"./icons/rubicons/share.svg": 63382,
	"./icons/rubicons/shield-check.svg": 94819,
	"./icons/rubicons/shield-hidden.svg": 79343,
	"./icons/rubicons/shield-x.svg": 14207,
	"./icons/rubicons/shield.svg": 23788,
	"./icons/rubicons/sliders-alt-horizontal.svg": 92895,
	"./icons/rubicons/sliders-alt-vertical.svg": 71577,
	"./icons/rubicons/sliders-horizontal.svg": 69448,
	"./icons/rubicons/sliders-vertical.svg": 69801,
	"./icons/rubicons/social-facebook.svg": 32751,
	"./icons/rubicons/speaker.svg": 50790,
	"./icons/rubicons/star-fill.svg": 83332,
	"./icons/rubicons/star.svg": 94037,
	"./icons/rubicons/stopwatch.svg": 43122,
	"./icons/rubicons/sun.svg": 10829,
	"./icons/rubicons/terminal-alt.svg": 63698,
	"./icons/rubicons/terminal.svg": 72175,
	"./icons/rubicons/thumbs-down.svg": 83295,
	"./icons/rubicons/thumbs-up.svg": 13374,
	"./icons/rubicons/trash-alt.svg": 67798,
	"./icons/rubicons/trash.svg": 9748,
	"./icons/rubicons/undo-alt.svg": 35607,
	"./icons/rubicons/undo.svg": 70737,
	"./icons/rubicons/unlock-alt.svg": 27079,
	"./icons/rubicons/unlock.svg": 14605,
	"./icons/rubicons/user-minus-alt.svg": 44888,
	"./icons/rubicons/user-minus.svg": 61969,
	"./icons/rubicons/user-plus-alt.svg": 68878,
	"./icons/rubicons/user-plus.svg": 98124,
	"./icons/rubicons/user.svg": 26229,
	"./icons/rubicons/users.svg": 53151,
	"./icons/rubicons/video-off.svg": 50527,
	"./icons/rubicons/video.svg": 86708,
	"./icons/rubicons/voicemail.svg": 4959,
	"./icons/rubicons/wallet.svg": 59449,
	"./icons/rubicons/warning-circle.svg": 10890,
	"./icons/rubicons/warning-triangle.svg": 46358,
	"./icons/rubicons/watch.svg": 95204,
	"./icons/rubicons/wifi-disabled.svg": 83833,
	"./icons/rubicons/wifi.svg": 33682,
	"./icons/rubicons/x-circle.svg": 75756,
	"./icons/rubicons/x-square.svg": 72482,
	"./icons/rubicons/x.svg": 4712,
	"./images/logos/main.png": 15625,
	"./images/logos/main.svg": 803,
	"./images/logos/main_alt.svg": 7178,
	"./images/logos/main_vf.svg": 22196,
	"./images/logos/saffron-company.png": 40759,
	"./images/logos/saffron-company.svg": 65581,
	"./images/logos/saffron.png": 61612,
	"./images/logos/saffron.svg": 40823,
	"./images/selfcare/flags/france.svg": 20325,
	"./images/selfcare/flags/germany.svg": 94916,
	"./images/selfcare/flags/united-kingdom.svg": 90035,
	"./images/selfcare/sample-banner-2.jpg": 90345,
	"./images/selfcare/sample-banner.png": 39897,
	"./images/selfcare/temp-bg.jpg": 55111,
	"./logos/main.png": 84457,
	"./logos/main.svg": 72694,
	"./logos/main_alt.svg": 59016,
	"./logos/main_vf.svg": 48543,
	"./scss/styles.scss": 27274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14432;